<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import GzzjwhBrowse from "./GzzjwhBrowse";
import GzzjwhEdit from "./GzzjwhEdit";
import GzzjwhForm from "./GzzjwhForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "Gzzjwh",
    components: { GzzjwhBrowse, GzzjwhEdit, GzzjwhForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.setNoticeId(null);
            this.editProps.showEdit = true;
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            if (this.editProps.showEdit === true) {
                return "GzzjwhEdit";
            } else if (this.editProps.showForm === true) {
                return "GzzjwhForm";
            } else {
                return "GzzjwhBrowse";
            }
        }
    },
    methods: {
        ...mapActions(["setNoticeId"])
    }
};
</script>
